export default __webpack_public_path__ + "static/media/ai.134cde68.svg";